import { getPaymentMethodId } from 'shared/utils/subscriptionV2Helpers';
import { SubscriptionDetailsV2Response } from 'state/internal/getSubscriptionDetails/types';

// determines whether the current subscription details page can display missing payment banner
export const isMissingPaymentV2 = (subscription: SubscriptionDetailsV2Response | undefined) => ({
  hasCompatibleSubscription:
    !subscription?.payment ||
    !subscription?.payment?.method ||
    (!subscription?.payment?.method?.source &&
      !Object.prototype.hasOwnProperty.call(subscription?.payment?.method, 'is_revocable') &&
      !Object.prototype.hasOwnProperty.call(
        subscription?.payment?.method,
        'paypal_account_email'
      )) ||
    !subscription?.payment?.method?.is_valid
});

// determines whether the subscription list page can display missing payment banner
export const useSubscriptionListMissingPaymentV2 = ({
  subscriptions
}: {
  subscriptions: SubscriptionDetailsV2Response[] | undefined;
}) => {
  const targetSubscription = subscriptions?.find(
    (sub) => isMissingPaymentV2(sub).hasCompatibleSubscription
  );

  return {
    hasCompatibleSubscription: Boolean(targetSubscription),
    missingPaymentId:
      targetSubscription && targetSubscription.payment.method
        ? getPaymentMethodId(targetSubscription.payment.method)
        : undefined
  };
};
